module.exports = __webpack_public_path__ + "static/04-selfmastery-e40164e4aa3b6574bc2df8caa2de4633.png";